import { render, staticRenderFns } from "./DropProjectOnResourceModal.vue?vue&type=template&id=70f4add2"
import script from "./DropProjectOnResourceModal.vue?vue&type=script&lang=js"
export * from "./DropProjectOnResourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports